export default "__VITE_ASSET__Dy$HicAB__"